
<!--
  画面名：-
  概要： 確認用ダイアログを表示するコンポーネント
  備考： -
-->

<!-- HTML -->
<template>
  <v-dialog v-model="iaDialog" max-width="30%" persistent>
    <v-card class="auth-dialog">
      <v-card-text style="padding-top:40px;padding-bottom:40px;">
        {{msg}}
      </v-card-text>
      <!-- ダイアログのアクション表示部分-->
      <v-card-actions class="action-content">
        <v-spacer></v-spacer>
        <!-- 閉じるボタン -->
        <v-btn small color="blue darken-1" flat @click="close" v-if="isClose">
          {{$language.LabelClose}}
        </v-btn>
        <!-- いいえボタン -->
        <v-btn v-if="!isYes && !isClose" small color="blue darken-1" flat @click="close">
          {{$language.LabelNo}}
        </v-btn>
        <!-- はいボタン -->
        <v-btn small color="blue darken-1" flat @click="agree" v-if="!isClose">
          {{$language.LabelYes}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<!-- /HTML -->

<script>
export default {
  // 親コンポーネントから値を受け取る
  props: {
    // はいボタンのみ使用するか判定する
    isYes: { type: Boolean, default: false },
    // 顔認証画面からの遷移か判定
    msg: String

  },
  data () {
    return {
      // ダイアログの表示切替用
      iaDialog: false,
      // 親から引き継ぎ情報を格納
      item: '',
      index: '',
      isClose: false,
      // 対象がモニタリングなのか冷蔵庫なのかを判断する。
      type: null,
    }
  },
  // コンポーネントの処理を記載
  methods: {
    // ダイアログの表示機能
    openDialog (item, index, type) {
      // ダイアログの表示をON
      this.iaDialog = true
      this.item = item
      this.index = index
      this.type = type
      // 雛形管理時の削除できない場合
      if (item !== undefined && item.isNotDelete) {
        this.isClose = true
      }
    },
    openWarnDialog(){
      this.iaDialog = true
      this.isClose = true
    },
    // ダイアログ閉じる処理
    close () {
      this.iaDialog = false
      this.isClose = false
      this.type = null
    },
    // 親の確定処理実行
    agree () {
      if (this.type === 'monitaring') {
        this.$emit('submitMonitaring', this.item, this.index)
      } else if (this.type === 'warmer') {
        this.$emit('submitWarmer', this.item, this.index)
      } else {
        this.$emit('submit', this.item, this.index)
      }
      this.iaDialog = false
      this.isClose = false
      this.type = null
    }
  }
}
</script>
